import { render, staticRenderFns } from "./FlagItem.vue?vue&type=template&id=a27e9aaa&scoped=true&"
import script from "./FlagItem.vue?vue&type=script&lang=js&"
export * from "./FlagItem.vue?vue&type=script&lang=js&"
import style0 from "./FlagItem.vue?vue&type=style&index=0&id=a27e9aaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27e9aaa",
  null
  
)

export default component.exports